import { render, staticRenderFns } from "./getTacAffiliate.vue?vue&type=template&id=46415443&lang=pug"
import script from "./getTacAffiliate.vue?vue&type=script&lang=js"
export * from "./getTacAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports